module.exports = __webpack_public_path__ + "img/icl.5110b881.png";